import { Component, Inject, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { SubjectRelay } from "../../../../shared/commands/subject-relay.class"
import { Observable, Subject } from 'rxjs';

import { MatStep, MatStepper } from '@angular/material/stepper';
import { StepperSelectionEvent } from "@angular/cdk/stepper";

import { DocumentPaSteps } from "../../../../static-types/entities/document-pa-steps";
import { ButtonActions } from '../../../../app.constants';
import { DocumentPersonneAvertie, EtatDocumentPa, CategoriePa } from "../../entities/document-pa.entity";
import { StepAction } from "../../entities/step-action-entity";
import { DocumentPersonneAvertieResult } from "../../entities/document-personne-avertie-result";
import { DocumentPaService } from "../../services/document-pa-service";
import { StepDefinitionPaEntity } from "../../entities/document-pa-step-definition-data.entity";

@Component({
	selector: 'documents-pa-stepper-eol',
	templateUrl: 'documents-pa-stepper-eol.html',
	styleUrls: ['documents-pa-stepper.css'],
})
export class DocumentsPaStepperEolComponent {

	@ViewChild('matStepEol1') matStepEol1!: MatStep;
	@ViewChild('matStepEol2') matStepEol2!: MatStep;
	@ViewChild('matStepEol3') matStepEol3!: MatStep;
	@ViewChild('matStepEol5') matStepEol5!: MatStep;
	@ViewChild('matStepEol6') matStepEol6!: MatStep;
	@ViewChild('matStepEol7') matStepEol7!: MatStep;
	@ViewChild('matStepEol9') matStepEol9!: MatStep;

	titrePage: string = "Création d'un document Personne avertie";
	currentPa$: Subject<DocumentPersonneAvertie> = new Subject<DocumentPersonneAvertie>();
	currentPa!: DocumentPersonneAvertie;
	paCategories: typeof CategoriePa = CategoriePa;
	
	constructor(@Inject(DocumentPaService) private documentPaService: DocumentPaService) {

		this.editCommandSubject.subscribe(
			(paResult: DocumentPersonneAvertieResult) => {
				this.matSteps = [this.matStepEol1, this.matStepEol2, this.matStepEol3, this.matStepEol5, this.matStepEol6, this.matStepEol7, this.matStepEol9];
				if (paResult.categorie === CategoriePa.EOL) {
					if (paResult.id > 0) {
						this.documentPaService.getStepDefinitionData(paResult.id).subscribe(
							(definitionStepData) => {
								if (definitionStepData.id) {
									this.currentPa = new DocumentPersonneAvertie();
									this.currentPa.id = paResult.id;
									this.currentPa.duplicatedId = paResult.duplicatedId;
									this.currentPa.numeroPa = definitionStepData.numeroPa;
									this.currentPa.commune = definitionStepData.commune;
									this.currentPa.parcIds = definitionStepData.parcIds;
									this.currentPa.description = definitionStepData.description;
									this.currentPa.horaires = definitionStepData.horaires;
									this.currentPa.nombreIntervenants = definitionStepData.nombreIntervenants;
									this.currentPa.dateDebut = Array.isArray(definitionStepData.dateDebut)
										? definitionStepData.dateDebut
										: null;
									this.currentPa.dateFin = Array.isArray(definitionStepData.dateFin)
										? definitionStepData.dateFin
										: null;
									this.currentPa.etat = EtatDocumentPa[paResult.etat as keyof typeof EtatDocumentPa];
									this.currentPa.responsableId = paResult.referentParcId;
									this.currentPa.lastCompletedStep = paResult.lastCompletedStep;
									this.currentPa.categorie = paResult.categorie;
									for (let i = 1; i <= this.matSteps.length; i++) {
										this.matSteps[i-1].completed = paResult.lastCompletedStep >= i;
									}
									this.titrePage = "Modification d'un document Personne avertie";
									if (paResult.duplicatedId > -1) {
										this.currentPa.duplicatedId = paResult.duplicatedId;
										this.titrePage = "Duplication d'un document Personne avertie";
									}
									// load step 1 date et initialiser formulaire
									this.currentPa$.next(this.currentPa);
								}
							}
						);
					} else {
						this.currentPa = new DocumentPersonneAvertie();
						this.currentPa.id = -1;
						this.currentPa.categorie = paResult.categorie;
						if (paResult.dateDebut) {
							this.currentPa.dateDebut = paResult.dateDebut;
						}
						if (paResult.dateFin) {
							this.currentPa.dateFin = paResult.dateFin;
						}
						if (paResult.numeroPa) {
							this.currentPa.numeroPa = paResult.numeroPa;
						}
						if (paResult.commune) {
							this.currentPa.commune = paResult.commune;
						}
						if (paResult.duree) {
							this.currentPa.duree = paResult.duree;
						}
						if (paResult.horaires) {
							this.currentPa.horaires = paResult.horaires;
						}
						if (paResult.nombreIntervenants) {
							this.currentPa.nombreIntervenants = paResult.nombreIntervenants;
						}
						if (paResult.description) {
							this.currentPa.description = paResult.description;
						}
						if (paResult.parcIds) {
							this.currentPa.parcIds = [Number(paResult.parcIds)];
						}
						this.titrePage = "Création d'un document Personne avertie";
						for (let i = 0; i < this.matSteps.length; i++) {
							this.matSteps[i].completed = false;
						}
						this.currentPa.categorie = paResult.categorie;
						// load step 1 date et initialiser formulaire
						this.currentPa$.next(this.currentPa);
					}
				}
			}
		);
	}

	stepChange(event: StepperSelectionEvent) {
		console.log('passage en step ', event.selectedIndex, ': ', event.selectedStep);
	}

	@Input() documentPaSteps!: DocumentPaSteps[];
	matSteps: MatStep[] = [];

	@Output() viewChange = new EventEmitter<'list' | 'steps'>();
	@Output() parcEnergieHasChange = new EventEmitter<StepDefinitionPaEntity>();

	private editCommandSubject = new SubjectRelay<DocumentPersonneAvertieResult>();
	@Input() set editCommand(obs: Observable<DocumentPersonneAvertieResult>) {
		this.editCommandSubject.registerSource(obs);
	}

	handleAction(stepAction: StepAction, stepper: MatStepper) {
		if (stepAction.buttonAction === ButtonActions.NEXT) {
			if (stepAction.documentPa != null) {
				if (this.currentPa && this.currentPa.categorie) {
					stepAction.documentPa.categorie = this.currentPa.categorie;
				}
				this.currentPa = stepAction.documentPa;
				this.currentPa$.next(this.currentPa);
				if (stepper && stepper.selected) {
					stepper.selected.completed = true; // move to next step
					stepper.next();
				}
			}
		} else if (stepAction.buttonAction === ButtonActions.RETURN_TO_LIST) {
			stepper.selectedIndex = 0;
			stepper.reset();
			this.titrePage = "Création d'un document Personne avertie";
			this.viewChange.emit('list');
		} else if (stepAction.buttonAction === ButtonActions.PREVIOUS) {
			stepper.previous();
		}
	}
	
	categoriePaHasChanged(stepDefinitionformData: StepDefinitionPaEntity) {
		if (this.currentPa) {
			if (this.currentPa.categorie !== stepDefinitionformData.categoriePa) {
				alert('Vous avez choisi un parc ' + stepDefinitionformData.categoriePa + '. Les onglets vont être reinitialisés.');
				this.parcEnergieHasChange.emit(stepDefinitionformData);
			}
		}
	}

}
